import { f as fetchHandler } from '../chuck/fetchHandler-BmcM6Yrg.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * safely send post request by json
 */ var deleteJson = function(url, origin) {
    if (origin === void 0) origin = window.location.origin;
    return function(requestBody, headers) {
        return fetchHandler("" + origin + url, {
            method: 'DELETE',
            headers: _extends({}, headers, {
                'Content-Type': 'application/json; charset=utf-8'
            }),
            body: JSON.stringify(requestBody),
            credentials: 'same-origin'
        }, 30000);
    };
};

export { deleteJson };
